import { PureComponent } from "react";
import { styled } from "@mui/material";
import injectStores from "../RootStore/injectStores";
import cardStyle from "./cardStyles/cardStyle";
import type ViewStore from "stores/ViewStore";
import { injectPropsChildren } from "shared/common/react";

type CardProps = {
  className?: string;
  plain?: boolean;
  raised?: boolean;
  background?: boolean;
  chart?: boolean;
  login?: boolean;
  children?: React.ReactNode;
  inset?: boolean;
  link?: boolean;
  viewportCard?: boolean;
  viewStore?: ViewStore;
  isMobile?: boolean;
};

const CardDiv = styled("div")<CardProps>(({ theme, ...props }) => ({
  border: "0",
  marginBottom: "0",
  marginTop: "0px",
  color: "rgba(0, 0, 0, 0.87)",
  width: "100%",
  // boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
  position: "relative",
  display: "flex",
  flexDirection: "column",
  minWidth: "0",
  wordWrap: "break-word",
  fontSize: ".875rem",
  ...(props.inset && { boxShadow: "none" }),
  ...(props.plain && { boxShadow: "none" }),
  ...(props.raised && { boxShadow: theme.shadows[4] }),
  ...(props.chart && { padding: theme.spacing(2) }),
  ...(props.login && { padding: theme.spacing(3) }),
  ...(props.link && { cursor: "pointer" }),
  ...(props.viewportCard || props.isMobile
    ? { borderRadius: 0 }
    : { borderRadius: "6px" }),
  ...(props.className && { className: props.className }),
}));

class CardBase extends PureComponent<CardProps> {
  render() {
    const {
      children,
      viewportCard = false,
      inset = false,
      plain = false,
      raised = false,
      background = false,
      chart = false,
      login = false,
      link = false,
    } = this.props;

    const childrenWithProps = injectPropsChildren(children, {
      viewportCard: viewportCard,
    });

    return (
      <CardDiv
        inset={inset}
        plain={plain}
        raised={raised}
        background={background}
        chart={chart}
        login={login}
        link={link}
        viewportCard={viewportCard}
        isMobile={this.props.viewStore?.isMobile}
      >
        {childrenWithProps}
      </CardDiv>
    );
  }
}

const Card = styled(injectStores(CardBase))(cardStyle);
export default Card;
